import { Tooltip } from 'antd';

import { useSaveMessagePhone } from '@app/components/LeadCard/ui/MessageHistory/components/LeadMessageText/hooks/useSaveMessagePhone';
import { ClientDuplicateModal } from '@app/components/Modals/ClientDuplicateModal';

import type { FC } from 'react';

interface LeadMessagePhoneProps {
  value: string;
  digits: string;
  countryId: number;
}

export const LeadMessagePhone: FC<LeadMessagePhoneProps> = ({
  value,
  digits,
  countryId,
}) => {
  const {
    savePhone,
    isSaving,
    hint,
    isAlreadySaved,
    maskedPhone,
    isDuplicateOpen,
    closeDuplicate,
    openExistingClient,
    mergeWithExistingClient,
  } = useSaveMessagePhone({
    digits,
    countryId,
  });

  return (
    <>
      <Tooltip title={hint}>
        <button
          type="button"
          className="LeadTextMessage__phone"
          data-testid="lead-message-phone"
          data-saved={isAlreadySaved || undefined}
          disabled={isSaving}
          onClick={savePhone}
        >
          {value}
        </button>
      </Tooltip>

      {/* Клиент с таким номером уже есть, и его карточку можно объединить с
          текущей — предлагаем объединение (us/11255). */}
      {isDuplicateOpen && (
        <ClientDuplicateModal
          open
          phone={maskedPhone}
          isMergePossible
          onCancel={closeDuplicate}
          onOpenClient={openExistingClient}
          onMerge={mergeWithExistingClient}
        />
      )}
    </>
  );
};
